<template>
  <div class="">
    <!-- <CoverPage />

    <div class="relative bg-white">
      <Cards1 class="blur pt-6" />
    
      <div
        class="absolute top-0 left-0 blur1 w-full h-553px flex justify-center items-center"
      >
        <p class="fsize60 sm-fsize25">Subscription coming soon....</p>
      </div>
    </div> -->
    <div>
      <Subscribe2 />
    </div>
    <div class="bge3ceff-opa rounded-t-5555 mt-12">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>

<script>
import DownloadApp from "./components/Download";
import Footer from "../Footer.vue";
import Cards1 from "./components/Cards1.vue";
import CoverPage from "./components/CoverPage";
import Subscribe2 from "./components/Subscribe2.vue";
export default {
  components: {
    CoverPage,
    Cards1,
    DownloadApp,
    Footer,
    Subscribe2,
  },
};
</script>

<style>
.blur {
  filter: blur(5px);
  -webkit-filter: blur(5px);
}
.blur1 {
  background-color: rgb(0, 0, 0);
  background-color: rgb(0, 0, 0, 0.68);
  color: white !important;

  font-weight: bold;
  z-index: 2;
  text-align: center;
}
.h-553px {
  height: 553px;
}
.fsize60 {
  font-size: 60px;
}
</style>
